import type { ClaimCode } from '../../../api/accounts'
import { formatDate } from '../../../lib/format'
import { CopyField } from '../../CopyField'

/** A freshly issued claim code: shown once, to send to the person along with its link. */
export function ClaimCodeNotice({ claim }: { claim: ClaimCode }) {
	return (
		<div className="stack">
			<p className="small" style={{ margin: 0 }}>
				Send this code (or the link) to them; it works once, until {formatDate(claim.expiresAt)}, and isn’t shown again.
			</p>
			<CopyField label="Claim code" value={claim.code} />
			<CopyField label="Claim link" value={claim.link} />
		</div>
	)
}
